import { Control } from 'react-redux-form';
import MaskedInput from 'react-text-mask';
import { validateEmail, validatePhone, validateNamePlain } from '../Validators';
import Select from '../Controls/Select';
import { enumTrustedContactRelationship } from '../Schemas/baseRrf';

const getTrustedContactFields = () => (
  [{
    model: '.firstName',
    RRFComp: Control.text,
    control: {
      label: 'First Name',
      placeholder: 'Enter first name',
      maxLength: 20,
      inputType: 'text',
      errors: {
        required: val => !val || !val.length,
        name: val => val && !validateNamePlain(val),
      },
    },
    error: {
      messages: {
        required: 'First Name is required.',
        name: 'First Name must contain only letters',
      },
    },
  }, {
    model: '.lastName',
    RRFComp: Control.text,
    control: {
      label: 'Last Name',
      placeholder: 'Enter last name',
      maxLength: 35,
      inputType: 'text',
      errors: {
        required: val => !val || !val.length,
        name: val => val && !validateNamePlain(val),
      },
    },
    error: {
      messages: {
        required: 'Last Name is required.',
        name: 'Last Name must contain only letters',
      },
    },
  }, {
    model: '.email',
    RRFComp: Control.text,
    control: {
      label: 'Email',
      placeholder: 'Enter email',
      inputType: 'text',
      errors: {
        required: val => !val || !val.length,
        isEmail: val => val && !validateEmail(val),
      },
    },
    error: {
      messages: {
        required: 'An email is required.',
        isEmail: val => `${val} is not a valid Email Address.`,
      },
    },
  }, {
    model: '.telephone',
    RRFComp: Control.text,
    control: {
      component: MaskedInput,
      parser: val => (val && val.replace(/\s|\(|\)|-/g, '')),
      mask: [' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      guide: false,
      maxLength: 15,
      label: 'Phone Number',
      placeholder: 'Enter phone number',
      inputType: 'text',
      errors: {
        required: val => !val || !val.length,
        isPhone: val => val && !validatePhone(val),
      },
    },
    error: {
      messages: {
        required: 'A phone number is required.',
        isPhone: val => `${val} is not a valid Telephone Number.`,
      },
    },
  }, {
    model: '.relationship',
    RRFComp: Control,
    control: {
      component: Select,
      display: enumTrustedContactRelationship[0][1],
      label: 'Relationship to Account Holder',
      inputType: 'select',
      options: enumTrustedContactRelationship,
    },
  }]
);

export default getTrustedContactFields;



// WEBPACK FOOTER //
// ./src/components/Forms/TrustedContact/TrustedContactFields.js